import { Box, Typography, AppBar, CardMedia, Divider, IconButton, Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import {
  Applicant,
  ApplicationProps,
  Broker,
  BrokerList,
  Declaration,
  Document,
  RiskProfileMaster,
  esignApplicationResponse,
  getDetailsByRefrenceType,
} from '../../redux-store/types/api-types';
import {
  esignApplication,
  getApplicationDetailsWithRefId,
} from '../../redux-store/actions/onBoarding';
import { useHistory } from 'react-router';
import { RootStateType } from '../../redux-store/reducers';
import { Footer, ListView } from '../commonComponents';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import {
  APPLICATION_LISTING_STATUS,
  directInvestmentDisabledDate,
  ESIGN_STATUS,
  RiskProfileEnabled,
} from '../../utils/constant';
import {
  getBrokers,
  provideConsentApplication,
  getDocuments,
  isFormValidForSubmission,
} from '../../redux-store/actions/application';
import { showError } from '../../redux-store/actions/auth';
import { ApplicationDetailsCommonLayout } from '../ApplicationDetails/index';
import { getNationalityList, riskProfileMasterData } from '../../redux-store/actions';
import { mdmsCountriesList, nationaliyType } from '../../redux-store/types/mdms';
import MFCheckbox from '../../lib/formik/Checkbox';
import { Formik } from 'formik';
import { DeclarationErrors } from '../../redux-store/middleware';
import { LoadingButton } from '@mui/lab';
import { Notes, SubHeading } from '../investors/components';
import { styles } from '../../Styles/styles';
import { DeclarationMaster, nriDeclaration, esignDeclaration } from './Declarations';
import {
  checkforDirectInvestment,
  checkValidationBasedOnDate,
  eSignDeclarationCheck,
} from '../../utils/utilityFunctions';

export const Item = styled('div')(({ theme }) => ({
  ...theme.typography.body2,
  paddingTop: '10px',
  marginLeft: '2px',
  color: theme.palette.text.secondary,
  fontSize: '15px',
  fontWeight: 500,
  letterSpacing: '0.5px',
}));
export const ItemDetails = styled('div')(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  fontSize: '16px',
  marginLeft: '2px',
  fontWeight: 700,
  letterSpacing: '0.5px',
  maxWidth: '100%',
  overflowWrap: 'anywhere',
}));
export const Gridstyles = styled('div')(({ theme }) => ({
  paddingLeft: '10%',
  [theme.breakpoints.only('xs')]: {
    paddingLeft: 0,
  },
}));

const initialValues: Declaration = {
  directInvestment: false,
  indirectInvestment: false,
  individualUbo: false,
  noIndividualOwnership: false,
  nonIndividualUbo: false,
  nriDeclaration: false,
};
export const getDeclaration = (application: ApplicationProps) =>
  application?.applicants?.find((applicant) => Number(applicant.applicant_type) === 1)?.declaration;

export default function InvestorApplication(): JSX.Element {
  const { referenceId } = useParams<{ referenceId: string }>();
  const dispatch = useDispatch();
  const history = useHistory();
  const { investor, auth } = useSelector((store: RootStateType) => store);
  const [loading, setLoading] = useState(false);
  const [application, setApplication] = useState<ApplicationProps>();
  const applicationDetailRef = useRef<HTMLDivElement>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const referenceDetail = useSelector(
    (store: RootStateType) => store.refrenceIdReducer
  ) as unknown as getDetailsByRefrenceType;

  const [fatcaDetails, setFatcaDetails] = useState(initialValues);

  const [documentsResponse, setDocumentResponse] = useState<Document>();
  const [riskProfileMasterResponse, setRiskProfileMasterResponse] = useState<
    RiskProfileMaster | undefined
  >({} as RiskProfileMaster);
  const [brokerList, setBrokerList] = useState<BrokerList>({} as BrokerList);
  const [nationalityMaster, setNationalityMaster] = useState<nationaliyType>();
  const [consentInfo, setConsentInfo] = useState('');

  const [loginInvestorDeclaration, setLoginInvestorDeclaration] = useState<Declaration>();

  useEffect(() => {
    const { token } = investor;
    if (!token) {
      history.push(`/investment-details/${referenceId}/details`);
    }
  }, []);

  useEffect(() => {
    (async function () {
      try {
        const _application = (await dispatch(
          getApplicationDetailsWithRefId(referenceId)
        )) as unknown as ApplicationProps;
        setApplication(_application);

        const brokersMasters = (await dispatch(getBrokers())) as unknown as BrokerList;
        setBrokerList(brokersMasters);
        let risk;
        if (RiskProfileEnabled) {
          risk = (await dispatch(riskProfileMasterData())) as unknown as RiskProfileMaster;
        }
        setRiskProfileMasterResponse(risk);
        const docResponse = (await dispatch(getDocuments())) as unknown as Document;
        setDocumentResponse(docResponse);
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        setNationalityMaster(nationalitiesMdmsMasters);
        const InvestorDeclarations = getDeclaration(_application) as Declaration;
        setLoginInvestorDeclaration(InvestorDeclarations);
        setFatcaDetails(InvestorDeclarations);
        if (InvestorDeclarations?.directInvestment || InvestorDeclarations?.indirectInvestment) {
          if (!_application?.signDetails?.url) {
            await isFormValidForSubmission(
              _application as ApplicationProps,
              risk,
              true,
              true,
              nationalitiesMdmsMasters,
              brokersMasters.broker_list as Broker[],
              documentsResponse,
              auth.role
            );
          }
          if (_application?.applicants?.length > 1) {
            if (
              (referenceDetail?.applicant_type === '2' ||
                referenceDetail?.applicant_type === '3') &&
              APPLICATION_LISTING_STATUS[_application?.status || ''] ===
                APPLICATION_LISTING_STATUS.sent_to_applicant1
            ) {
              throw `Esign pending with joint applicant(s)`;
            }
            if (
              referenceDetail?.applicant_type === '3' &&
              [
                APPLICATION_LISTING_STATUS.sent_to_applicant1,
                APPLICATION_LISTING_STATUS.approved_by_applicant1,
              ].includes(APPLICATION_LISTING_STATUS[_application?.status || ''])
            ) {
              throw `Esign pending with joint applicant(s)`;
            }
          }
          throw '';
        }
      } catch (e) {
        typeof e === 'string' && setConsentInfo(e);
        console.error((e as Error).message);
      } finally {
        setLoading(false);
      }
    })();
    setLoading(true);
  }, []);

  const handleEsign = async (values: Declaration) => {
    const nriDeclarationCheck = eSignDeclarationCheck(
      application?.applicants?.find((applicant) => applicant?.applicant_type === '1') as Applicant,
      application?.createdAt || ''
    );
    try {
      setIsSubmitting(true);
      const { signDetails, id, applicants = [] } = application || {};
      if (signDetails?.url) {
        if (
          applicants?.length > 1 &&
          (referenceDetail?.applicant_type === '2' || referenceDetail?.applicant_type === '3') &&
          APPLICATION_LISTING_STATUS[application?.status || ''] ===
            APPLICATION_LISTING_STATUS.sent_to_applicant1
        ) {
          throw `Esign pending with joint applicant(s)`;
        }
        if (
          applicants?.length > 1 &&
          referenceDetail?.applicant_type === '3' &&
          APPLICATION_LISTING_STATUS[application?.status || ''] !==
            APPLICATION_LISTING_STATUS.approved_by_applicant2
        ) {
          throw `Esign pending with joint applicant(s)`;
        }
        window.open(signDetails?.url, '_blank');
        return;
      }
      if (
        !application?.distributor_id
          ? checkforDirectInvestment(
              application?.createdAt || '',
              application?.distributorName || ''
            ) && !values.directInvestment
          : !values.indirectInvestment
      ) {
        throw new DeclarationErrors('Declaration(s) is required');
      }
      if (!values.nriDeclaration && nriDeclarationCheck) {
        throw new DeclarationErrors('NRI Declaration is required');
      }
      if (id) {
        let InvestorDeclarations = getDeclaration(application as ApplicationProps);
        setLoginInvestorDeclaration(InvestorDeclarations);
        if (ESIGN_STATUS.NOT_GENERATED === application?.signDetails?.status) {
          await isFormValidForSubmission(
            application as ApplicationProps,
            riskProfileMasterResponse,
            true,
            true,
            nationalityMaster,
            brokerList.broker_list as Broker[],
            documentsResponse,
            auth.role
          );
        }
        const applicationResponse = (!(
          InvestorDeclarations?.directInvestment || InvestorDeclarations?.indirectInvestment
        ) ||
        (!InvestorDeclarations?.nriDeclaration && nriDeclarationCheck)
          ? await dispatch(
              provideConsentApplication({
                body: {
                  directInvestment: values.directInvestment || false,
                  indirectInvestment: values.indirectInvestment || false,
                  ...(nriDeclarationCheck && { nriDeclaration: values.nriDeclaration }),
                },
                referenceId: referenceId,
              })
            )
          : application) as unknown as ApplicationProps;
        setApplication(applicationResponse);
        InvestorDeclarations = getDeclaration(applicationResponse as ApplicationProps);
        setLoginInvestorDeclaration(InvestorDeclarations);

        const response = (await dispatch(
          esignApplication(referenceId)
        )) as unknown as esignApplicationResponse;
        setApplication({
          ...application,
          signDetails: response,
        } as unknown as ApplicationProps);
        window.open(response?.url, '_blank');
        return;
      }
    } catch (e) {
      if (e instanceof DeclarationErrors) {
        dispatch(showError((e as DeclarationErrors).message));
      }
      if (typeof e === 'string') {
        setConsentInfo(e);
        dispatch(showError(e as string));
      }
      console.error((e as Error).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Formik initialValues={fatcaDetails} onSubmit={handleEsign} enableReinitialize={true}>
      {({ handleSubmit, values, setValues }) => (
        <Box
          sx={{
            bgcolor: { xs: '', sm: 'rgba(238, 244, 251, 0.5)' },
          }}
          component="form"
          onSubmit={handleSubmit}>
          <IconButton
            sx={{
              position: 'fixed',
              right: 0,
              bottom: 75,
              borderRadius: '5px  0 0 5px',
              '&,:hover': {
                bgcolor: 'primary.main',
              },
            }}
            onClick={() => applicationDetailRef.current?.scrollIntoView({ behavior: 'smooth' })}>
            <ArrowUpwardIcon fontSize="large" sx={{ color: 'common.white' }} />
          </IconButton>
          <AppBar position="fixed" elevation={0} sx={{ bgcolor: 'common.white' }}>
            <Box>
              <CardMedia
                component="img"
                src="/images/nippon-logo.svg"
                alt="Logo"
                sx={{ width: { xs: '220px', sm: '300px' }, m: 3 }}
              />
            </Box>
          </AppBar>
          <Divider sx={{ display: { xs: 'block', sm: 'none' } }} />
          <Box sx={{ py: 5, px: { xs: 5, sm: 10 } }} ref={applicationDetailRef}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                mb: 2,
                justifyContent: 'space-between',
                mt: 10,
              }}>
              <Typography sx={{ fontSize: 20, fontWeight: 600, color: 'primary.main', mb: 4 }}>
                Application Details
              </Typography>
              {application?.editable && (
                <IconButton disabled={isSubmitting}>
                  <CardMedia
                    component="img"
                    src="/images/edit-icon-outlined.svg"
                    alt="Edit Icon"
                    sx={{ width: 'unset' }}
                    onClick={() =>
                      history.push(
                        `/investment-details/${referenceId}/investor-edit-application/distributor-details`,
                        {
                          id: application?.id,
                          applicant1ReferenceId: application?.applicant1ReferenceId,
                        }
                      )
                    }
                  />
                </IconButton>
              )}
            </Box>
            {application && (
              <>
                <ApplicationDetailsCommonLayout
                  loading={loading}
                  application={application as ApplicationProps}
                />
                <Grid item xs={12}>
                  {!application?.distributor_id ? (
                    checkforDirectInvestment(
                      application?.createdAt || '',
                      application?.distributorName
                    ) && (
                      <>
                        <SubHeading sx={styles.DeclarationHeading}>
                          Declaration for Direct Plan Investor
                        </SubHeading>
                        <MFCheckbox
                          name={`directInvestment`}
                          disabled={loginInvestorDeclaration?.directInvestment as boolean}
                          label={esignDeclaration(DeclarationMaster.direct.directInvestment)}
                          sx={styles.DeclarationCheckboxStyle}
                          onChange={({ target: { checked } }) => {
                            setValues({
                              ...values,
                              directInvestment: checked,
                              indirectInvestment: false,
                            });
                          }}
                        />
                      </>
                    )
                  ) : (
                    <>
                      <SubHeading sx={styles.DeclarationHeading}>
                        Declaration for Direct Plan Investor
                      </SubHeading>
                      <MFCheckbox
                        name={`indirectInvestment`}
                        disabled={loginInvestorDeclaration?.indirectInvestment as boolean}
                        label={esignDeclaration(DeclarationMaster.direct.indirectInvestment)}
                        sx={styles.DeclarationCheckboxStyle}
                        onChange={({ target: { checked } }) => {
                          setValues({
                            ...values,
                            indirectInvestment: checked,
                            directInvestment: false,
                          });
                        }}
                      />
                    </>
                  )}
                </Grid>
                <Grid item xs={12}>
                  {eSignDeclarationCheck(
                    application?.applicants?.find(
                      (applicant) => applicant?.applicant_type === '1'
                    ) as Applicant,
                    application?.createdAt || ''
                  ) && (
                    <MFCheckbox
                      name={`nriDeclaration`}
                      disabled={loginInvestorDeclaration?.nriDeclaration as boolean}
                      label={
                        <ListView
                          list={nriDeclaration}
                          disabled={loginInvestorDeclaration?.nriDeclaration as boolean}
                        />
                      }
                      sx={styles.DeclarationCheckboxStyle}
                    />
                  )}
                </Grid>
                {!isSubmitting && consentInfo && (
                  <Box sx={{ mt: 4 }}>
                    <Notes displayContent={consentInfo} />
                  </Box>
                )}
                {![ESIGN_STATUS.SIGNED, ESIGN_STATUS.EXPIRED].includes(
                  application?.signDetails?.status
                ) && (
                  <Box sx={{ textAlign: 'center' }}>
                    <LoadingButton
                      variant="contained"
                      loadingPosition="start"
                      type="submit"
                      sx={{
                        color: 'common.white',
                        minWidth: '200px',
                        mt: consentInfo ? 1 : 4,
                        fontWeight: 600,
                        lineHeight: 1.5,
                        px: 4,
                      }}
                      loading={isSubmitting}
                      disabled={
                        isSubmitting ||
                        (((loginInvestorDeclaration?.directInvestment ||
                          loginInvestorDeclaration?.indirectInvestment) &&
                          consentInfo) as boolean)
                      }>
                      {'e-Sign'}
                    </LoadingButton>
                  </Box>
                )}
              </>
            )}
          </Box>
          <Footer />
        </Box>
      )}
    </Formik>
  );
}
